<template>
  <main id='Guide' v-if='kirby.page.template == "guide"' v-scroll-lock='true'>
    <div class='overlay' :class='{phone: size=="phone"}'>
      <header>
        <h5 v-html="kirby.page.strings.subtitle" />
        <h1 v-html="kirby.page.strings.title" />
        <close />
      </header>
      <section class='mid'>
        <section class='left half'>
          <summary v-html='kirby.page.strings.writer' />
          <footer>
            <details v-for='(detail, index) in yaml(kirby.page.strings.details)' :open='current==index ? "true" : null '>
              <summary @click.prevent='current=index' v-html='detail.title' />
              <section v-html='detail.disclaimer' />
            </details>
          </footer>
        </section>
        <PlayList class='half' :stories='removeLineBreaks(yaml(kirby.page.strings.stories))' target='_blank' />
      </section>
    </div>
  </main>
</template>

<style scoped>

  main {
    display: flex;
    flex-direction: column;
    justify-content: center;
    position: fixed;
    overflow-y: scroll;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 9999;
  }

  div.overlay {
    max-width: var(--main-max-width);
    background-color: var(--mintwhite);
    width: calc(100% - 2rem);
    box-sizing: border-box;
    padding: var(--overlaypadding);
    border-radius: 2rem;
    position: relative;
    margin: var(--overlaymargin);
  }

  div.overlay.phone {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
  }

  section.guides {
    display: flex;
    gap: 1.5em;
  }

  header {
    margin-bottom: 3em;
  }

  .half {
    flex-grow: 1;
    flex-basis: 0;
    margin: 0;
  }

  section.active {
    gap: 0em;
  }

  section.mid {
    display: flex;
    gap: 0em 4em;
    vertical-align: top;
    flex-direction: var(--columns-or-rows)
  }

  div.active:not(.expanded) {
    width: 0;
    padding: 0;
    opacity: 1;
    margin: 0;
    overflow: hidden;
  }

  h5 {
    font-size: 1.2em;
  }

  h1 {
    margin-top: 0.15em;
    font-size: 2.5em;
  }

  summary {
    margin-bottom: 3em;
    flex-grow: 5;
  }

  button {
    padding: 1em 3em;
    border-radius: 2em;
    margin-bottom: 0;
  }

  svg {
    width: 3rem;
    height: 3rem;
    position: absolute;
    top: 2rem;
    right: 2rem;
  }


 details summary {
   cursor: pointer;
   font-size: 1.125em;
   margin-bottom: 0.75em;
 }

 details {
   margin-bottom: 0.5em;
 }

 details:last-of-type {
   margin-bottom: 2em;
 }

 details section {
   padding-left: 1.5em;
   font-size: 0.9em;
   line-height: 1.25em;
   margin-bottom: 1.5em;
   letter-spacing: -.001em;
 }

</style>

<script>
import mixins from '.././mixins.js'
import Vue from 'vue';
import VScrollLock from 'v-scroll-lock';
import { enableBodyScroll, disableBodyScroll } from 'body-scroll-lock'

Vue.use(VScrollLock, {
  bodyScrollOptions: {
    reserveScrollBarGap: true,
  },
  enableBodyScroll,
  disableBodyScroll,
})

export default {
  mixins: [mixins],
  data: function() {
    return {
      current: 0
    }
  },
  mounted: function(){
    this.$emit("addReasonToShowVeil");
  },
  destroyed: function(){
    this.$emit("removeReasonToShowVeil");
  }
}
</script>
